import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { UrlDisplayHelper } from '../../../../../../../utils/url-display-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Performance Max on the Google search results page (mobile): the text ad at
 * the top of the results with a landscape image, and sitelinks as a row of chips.
 */
@Component({
  selector: 'app-pmax-google-search-mobile-03',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './google-search-mobile-03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './google-search-mobile-03.component.scss'
})
export class PmaxGoogleSearchMobile03PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton tab widths under the search box, in px. */
  readonly tabWidths = [16, 56, 60, 44, 16];

  /** Google joins up to two headlines on mobile. */
  get headline(): string {
    return this.data.headlines.slice(0, 2).join(' - ') || 'Your headlines appear here';
  }

  /** Landscape image; '' until one is uploaded and measured. */
  get image(): string {
    return CreativeImageRouterHelper.resolve(this.data.images, 'landscape');
  }

  get imageResolving(): boolean {
    return CreativeImageRouterHelper.isResolving(this.data.images);
  }

  get description(): string {
    return this.data.descriptions.slice(0, 2).join(' ') || 'Your descriptions appear here.';
  }

  /** Host plus path of the destination URL, without scheme or query. */
  get displayUrl(): string {
    const host = UrlDisplayHelper.hostOf(this.data.url);
    try {
      const path = new URL(this.data.url).pathname.replace(/\/+$/, '');
      return host + path;
    } catch {
      return host;
    }
  }
}
